import * as sessionStorage from 'lib/browser/sessionStorage';

export const FAVOURITE_STORAGE_KEY = 'qantas_hotels_temp_favourite_property_id';

export const registerTempFavouritePropertyId = (propertyId) => {
  sessionStorage.set(FAVOURITE_STORAGE_KEY, propertyId);
};

export const getTempFavouritePropertyId = () => {
  return sessionStorage.get(FAVOURITE_STORAGE_KEY);
};

export const clearTempFavouritePropertyId = () => {
  sessionStorage.set(FAVOURITE_STORAGE_KEY, null);
};
